import { Injectable } from '@angular/core';
import { StorageKey } from '../enums/storage-key.enum';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  // metodo per ottenere un dato dal localstorage
  // NB, facciamo sempre il parsing che alla fine ci serve sempre
  getFromLocalStorage<T = unknown>(key: StorageKey): T | null {
    const value = localStorage.getItem(key);
    return this.parseJSON<T>(value);
  }

  // Metodo per ottenere un dato dal sessionStorage
  // NB, facciamo sempre il parsing che alla fine ci serve sempre
  getFromSessionStorage<T = unknown>(key: StorageKey): T | null {
    const value = sessionStorage.getItem(key);
    return this.parseJSON<T>(value);
  }

  // Funzione per il recupero dei dati dall'uno o dall'altro
  getFromLocalOrSessionStorage<T = unknown>(key: StorageKey): T | null {
    return this.getFromLocalStorage<T>(key) || this.getFromSessionStorage<T>(key);
  }

  setToLocalStorage<T = unknown>(key: StorageKey, value: T): void {
    localStorage.setItem(key, JSON.stringify(value));
  }

  setToSessionStorage<T = unknown>(key: StorageKey, value: T): void {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  removeFromLocalStorage(key: StorageKey): void {
    localStorage.removeItem(key);
  }

  private parseJSON<T>(value: string | null): T | null {
    if (value) {
      try {
        return JSON.parse(value) as T;
      } catch {
        // error parsing json
        return null;
      }
    }
    return null;
  }

  clearStorage() {
    localStorage.clear();
    sessionStorage.clear();
  }
}
